// removed by extract-text-webpack-plugin
module.exports = {"ExperienceFooter":"NavigationFooter__ExperienceFooter__3g6wL","active":"NavigationFooter__active__39oKH","CurrentLocation":"NavigationFooter__CurrentLocation__18PWF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExperiencesLandingPage/NavigationFooter/NavigationFooter.scss
// module id = 680
// module chunks = 0